import { Component, OnInit, ViewChild } from '@angular/core';
import { GraphQLClient } from '../../shared/services/graph-qlclient.service';
import gql from 'graphql-tag';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { tipo_cuenta_bancaria } from './../../shared/object/tipo_cuenta_bancaria.model';
import { ModalDirective } from 'ng-uikit-pro-standard/lib/free/modals/modal.directive';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ValidadoresService } from 'src/app/shared/validadores/validadores';
import { NotificacionGenerica } from 'src/Wheel.Styles.HighVolume/Notificacion';
import { TipoMensaje } from 'src/Wheel.Styles.HighVolume/Mensaje';

@Component({
  selector: 'app-tipo-cuenta',
  templateUrl: './tipo-cuenta.component.html',
  styleUrls: ['./tipo-cuenta.component.scss'],
  providers: [SecurityService, ValidadoresService]
})
export class TipoCuentaComponent implements OnInit {
  private client: GraphQLClient = null;
  formulario: FormGroup;
  tipocuentaList: tipo_cuenta_bancaria[];
  selectedTipoCuenta: tipo_cuenta_bancaria;
  tipocuenta: tipo_cuenta_bancaria;
  public nombre:string;
  public codigo:number;
  @ViewChild('agregarTipoCuenta', { static: true }) agregarModal: ModalDirective;
  @ViewChild('editarTipoCuenta', { static: true }) editarModal: ModalDirective;
  public codgo_modulo:number = 10;
  public rut_usuario =  Number(this.accesolocalstorage.getRutUsuario());


  constructor(client: GraphQLClient,
    private formBuilder: FormBuilder, 
    private accesolocalstorage: SecurityService,
    public validadores: ValidadoresService
    ){
    this.client = client;
    this.buildForm();
  }

  buildForm() {
    this.formulario = this.formBuilder.group({
      codigo: [''],
      nombre: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(50)]],
      activado: [true]
    });
  }

  ngOnInit() {
    this.selectedTipoCuenta = {
      codigo: null,
      nombre: '',
      activado:true
    };
    this.obtenerDatosTipoCuenta();
  }

  obtenerDatosTipoCuenta() {
    let self = this; 
    this.client.query({
      query: gql`
      query{
        tipo_cuenta_bancaria{
          obtenerTodos{
            respuesta{
              registros{
                codigo
                nombre
                activado
              }
            }
          }
        }
      }
      `,
      fetchPolicy: 'network-only',
    }, function (respuesta) {
      self.tipocuentaList = respuesta.data.tipo_cuenta_bancaria.obtenerTodos.respuesta.registros;
    });
  }

  showNew() {
    this.formulario.reset();
    this.formulario.get('nombre').enable();
    this.formulario.get('activado').setValue(true);
  }

  insertar() {
    this.selectedTipoCuenta.nombre = this.formulario.controls["nombre"].value;
    this.postTipoCuenta(this.selectedTipoCuenta);
  }

  postTipoCuenta(tipocuenta:tipo_cuenta_bancaria) {
    let self = this;
    var bodyx = tipocuenta;
    this.client.mutate({
      mutation: gql`
      mutation($entidad: tipo_cuenta_bancariaInputType)
      {
        tipo_cuenta_bancaria
        {
          agregar(entidad: $entidad) {
            respuesta{
              codigo
              nombre
              activado
            }
          }
        }
      }
      `,
      variables: {
        'entidad': bodyx,
      }
    },
      function (respuesta) {
        if (respuesta.data.tipo_cuenta_bancaria.agregar.respuesta != undefined) {
          setTimeout(() => self.obtenerDatosTipoCuenta(), 1000);
        }
      });
  }

  showForEdit(tipocuenta: tipo_cuenta_bancaria) {
    this.codigo = tipocuenta.codigo;
    this.formulario.get('codigo').setValue(tipocuenta.codigo);
    this.formulario.get('nombre').setValue(tipocuenta.nombre);
    this.formulario.get('activado').setValue(tipocuenta.activado);
  }


  actualizar() {
    this.selectedTipoCuenta.codigo = this.formulario.controls["codigo"].value;
    this.selectedTipoCuenta.nombre = this.formulario.controls["nombre"].value;
    this.selectedTipoCuenta.activado = this.formulario.controls["activado"].value;
    this.refrescar(this.selectedTipoCuenta);
  }

  refrescar(tipocuenta: tipo_cuenta_bancaria) {
    let self = this;
    var bodyx = tipocuenta;
    delete tipocuenta["__typename"];
    this.client.mutate({
      mutation: gql`
      mutation($entidad: tipo_cuenta_bancariaInputType)
      {
        tipo_cuenta_bancaria
        {
          modificar(entidad: $entidad) {
            respuesta{
              codigo
              nombre
              activado
            }
          }
        }
      }
      `,
      variables: {
        'entidad': bodyx,
      }
    },
      function (respuesta) {
        if (respuesta.data.tipo_cuenta_bancaria.modificar.respuesta != undefined) {
          setTimeout(() => self.obtenerDatosTipoCuenta(), 1000);
        }
      });
  }

  cambiaEstado(tipocuenta:tipo_cuenta_bancaria)
  {
    if (tipocuenta.activado)
    {
      tipocuenta.activado = false; 
    }
    else
    {
      tipocuenta.activado = true;
    }
    this.refrescar(tipocuenta);
  }

  obtenerDatosSegunFiltro(filtro_nombre:string) {
    let self = this;
    self.selectedTipoCuenta = {
      codigo: null,
      nombre: '',
      activado:true
    };
    var bodyx = self.selectedTipoCuenta;
    if (filtro_nombre != undefined){
      bodyx.nombre = filtro_nombre;
    }
    this.client.mutate({
      mutation: gql`
      query ($entidad:tipo_cuenta_bancariaInputType){
        tipo_cuenta_bancaria{
          obtenerSegunFiltro(filtro:{
            exacto:$entidad
          })
          {
            respuesta
            {
              registros
              {
                codigo
                nombre
                activado
              }
            }
          }
        }
      }
      `,
      variables: {
        'entidad': bodyx,
      }
    },
      function (respuesta) {
        self.tipocuentaList = respuesta.data.tipo_cuenta_bancaria.obtenerSegunFiltro.respuesta.registros;
      });
  }

  showModalAgregar() {
    const self = this;
    let codigo_operacion = 3
    this.client.query({
      query: gql`
      query ($rut_usu:Decimal, $codgo_modulo:Decimal, $cod_operacion:Decimal)
      {
        rol_operacion
        {
          operacionPermitida(rut_usu:$rut_usu, codgo_modulo: $codgo_modulo, cod_operacion:$cod_operacion)
          {
            mensajes
            {
              texto
              tipo
            }
            respuesta
          }
        }
      }
        `,
      variables: {
        'rut_usu': self.rut_usuario,
        'codgo_modulo': self.codgo_modulo,
        'cod_operacion': codigo_operacion,
      },
      fetchPolicy: 'no-cache',
    }, function (respuesta) {
      const notificacion: NotificacionGenerica<string> = NotificacionGenerica.parse(respuesta.data.rol_operacion.operacionPermitida);
      if (notificacion.mensajes[0].tipo == TipoMensaje.SUCCESS) {
        self.agregarModal.show();
      }
      else {
        alert(notificacion.mensajes[0].texto);
      }
    });
  }
  showModalModificar() {
    const self = this;
    let codigo_operacion = 2
    this.client.query({
      query: gql`
      query ($rut_usu:Decimal, $codgo_modulo:Decimal, $cod_operacion:Decimal)
      {
        rol_operacion
        {
          operacionPermitida(rut_usu:$rut_usu, codgo_modulo: $codgo_modulo, cod_operacion:$cod_operacion)
          {
            mensajes
            {
              texto
              tipo
            }
            respuesta
          }
        }
      }
        `,
      variables: {
        'rut_usu': self.rut_usuario,
        'codgo_modulo': self.codgo_modulo,
        'cod_operacion': codigo_operacion,
      },
      fetchPolicy: 'no-cache',
    }, function (respuesta) {
      const notificacion: NotificacionGenerica<string> = NotificacionGenerica.parse(respuesta.data.rol_operacion.operacionPermitida);
      if (notificacion.mensajes[0].tipo == TipoMensaje.SUCCESS) {
        self.editarModal.show();
      }
      else {
        alert(notificacion.mensajes[0].texto);
      }
    });
  }

  permitirCambioEstado(tipocuenta:tipo_cuenta_bancaria) {
    const self = this;
    let codigo_operacion = 4
    this.client.query({
      query: gql`
      query ($rut_usu:Decimal, $codgo_modulo:Decimal, $cod_operacion:Decimal)
      {
        rol_operacion
        {
          operacionPermitida(rut_usu:$rut_usu, codgo_modulo: $codgo_modulo, cod_operacion:$cod_operacion)
          {
            mensajes
            {
              texto
              tipo
            }
            respuesta
          }
        }
      }
        `,
      variables: {
        'rut_usu': self.rut_usuario,
        'codgo_modulo': self.codgo_modulo,
        'cod_operacion': codigo_operacion,
      },
      fetchPolicy: 'no-cache',
    }, function (respuesta) {
      const notificacion: NotificacionGenerica<string> = NotificacionGenerica.parse(respuesta.data.rol_operacion.operacionPermitida);
      if (notificacion.mensajes[0].tipo == TipoMensaje.SUCCESS) {
        self.cambiaEstado(tipocuenta);
      }
      else {
        alert(notificacion.mensajes[0].texto);
      }
    });
  }
}
